
{
  "title": "選擇您的方案",
  "subtitle": "為您的業務需求選擇完美的方案",
  "buttons": {
    "signUp": "註冊",
    "currentPlan": "目前方案",
    "purchase": "購買",
    "notAvailable": "不可用"
  },
  "comparison": {
    "headers": {
      "features": "比較方案"
    },
    "badges": {
      "whatsapp": "WhatsApp",
      "premium": "成長"
    },
    "features": {
      "listings": "服務列表",
      "categories": "類別",
      "areas": "服務區域",
      "profile": "商戶檔案",
      "verifiedBadge": "驗證徽章",
      "analytics": "列表分析",
      "priority": "優先排序"
    },
    "values": {
      "allServiceAreas": "所有服務區域"
    },
    "included": "包含",
    "notIncluded": "不包含"
  },
  "pricingTable": {
    "free": {
      "title": "免費",
      "price": "HK$0",
      "period": "永久",
      "description": "適合初學者",
      "features": {
        "maxListings": "1個服務列表",
        "singleCategory": "每個列表單一類別",
        "maxAreas": "最多3個服務區域",
        "basicProfile": "基本個人資料功能"
      }
    },
    "whatsapp": {
      "title": "WhatsApp 驗證",
      "price": "HK$100",
      "period": "一次性",
      "description": "獲得WhatsApp驗證徽章",
      "features": {
        "maxListings": "1個服務列表",
        "singleCategory": "每個列表單一類別",
        "maxAreas": "最多3個服務區域",
        "basicProfile": "基本個人資料功能",
        "verifiedBadge": "WhatsApp驗證徽章",
        "listingAnalytics": "列表分析"
      }
    },
    "premium": {
      "title": "高級版",
      "price": "HK$500",
      "period": "月",
      "description": "成長所需的一切",
      "features": {
        "unlimitedListings": "無限服務列表",
        "multipleCategories": "每個列表多個類別",
        "enhancedProfile": "增強個人資料功能",
        "verifiedBadge": "WhatsApp驗證徽章",
        "priorityPlacement": "搜尋優先排序",
        "listingAnalytics": "列表分析"
      }
    }
  },
  "faq": {
    "title": "常見問題",
    "howToStart": "如何開始？",
    "howToStartAnswer": "只需註冊一個帳戶，您就可以立即開始瀏覽服務。",
    "howToStartAnswerLoggedIn": "您已經註冊了！您可以開始創建列表或升級到高級方案。",
    "howToUpgrade": "如何升級我的方案？",
    "howToUpgradeAnswer": "您可以隨時從帳戶設定升級您的方案。",
    "howToUpgradeAnswerGuest": "請先註冊帳戶，然後您可以選擇您偏好的方案。",
    "canCancel": "可以隨時取消嗎？",
    "canCancelAnswer": "是的，您可以隨時取消訂閱。您目前的權益將持續到計費週期結束。",
    "paymentMethods": "您接受哪些付款方式？",
    "paymentMethodsAnswer": "Stripe Checkout 會根據您的地區與 Stripe 可用性，在結帳時直接顯示支援的付款方式。",
    "tierDifference": "層級之間有什麼區別？",
    "tierDifferenceAnswer": "每個層級提供不同的功能和限制。高級用戶可獲得無限列表和高級功能。"
  }
}
